import { render, staticRenderFns } from "./HealthAdxFilterForm.vue?vue&type=template&id=973368ba"
import script from "./HealthAdxFilterForm.vue?vue&type=script&lang=js"
export * from "./HealthAdxFilterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports